import TopMenu from '../../components/TopMenu/TopMenu.vue'
import Footer from '../../components/Footer/Footer.vue'

export default {
  data: function() {
    return {
      language: this.$store.getters.language,
      supportedLanguages: this.$store.getters.supportedLanguages
    }
  },
  methods: {
    goToContactFromAdviceAndSupport: function () {
      let url = '/en/contact'

      switch (this.$store.getters.language.value) {
        case 'nl':
          url = '/nl/contact'
          break
      }

      window.location.href = url;
    }
  },
  computed: {
    section1: function() {
      let title = {
        _1: 'Advice',
        _2: 'and support'
      }

      switch (this.language.value) {
        case 'nl':
          title = {
            _1: 'Advies',
            _2: 'en ondersteuning'
          }
      }

      return {
        title: title
      }
    },
    contactButton: function() {
      let buttonTxt = 'Contact us for more information<br/>about all our services'

      switch (this.language.value) {
        case 'nl':
          buttonTxt = 'Contacteer ons voor meer informatie<br/>over al onze diensten'
      }

      return buttonTxt
    },
    trumpsIntro: function () {
      let txt = 'Our services are not limited to sampling and delivering only.'

      switch (this.$store.getters.language.value) {
        case 'nl':
          txt = 'Onze diensten zijn niet beperkt tot enkel staalnames en transport.'
      }

      return txt;
    },
    trumps: function() {
      const trumpsArr = []
      let title1 = 'Experience'
      let icon1 = 'icon-briefcase'
      let text1 = 'The quality of your product is essential. With our wide range of experience in different industries our team of specialists are happy to assist in identifying risks of contamination.'

      let title2 = 'Advice'
      let icon2 = 'icon comments'
      let text2 = 'We also provide advice concerning the type, quantity, timing of samples to be taken for each product.'

      let title3 = 'Support'
      let icon3 = 'icon map signs'
      let text3 = 'When contamination issues occur we can help our clients identify the origin of this problem and how to avoid this in the future.'

      switch (this.$store.getters.language.value) {
        case 'nl':
          title1 = 'Ervaring'
          text1 = 'De kwaliteit van uw product is essentieel. Met onze brede waaier aan ervaring in verschillende sectoren is ons team van specialisten meer dan bereid u te assisteren in het identificeren waar contaminatie mogelijk is.'

          title2 = 'Advies'
          text2 = 'We geven ook advies voor wat betreft het type, de hoeveelheid en de tijdstippen waarop stalen genomen moeten worden voor elk product.'

          title3 = 'Ondersteuning'
          text3 = 'Wanneer contaminatie zich voordoet, kunnen we onze klanten helpen bij het identificeren van de oorzaak van het probleem en hoe dit vermeden kan worden in de toekomst.'

          break
      }

      trumpsArr.push({
        title: title1,
        icon: icon1,
        text: text1
      })
      trumpsArr.push({
        title: title2,
        icon: icon2,
        text: text2
      })
      trumpsArr.push({
        title: title3,
        icon: icon3,
        text: text3
      })

      return trumpsArr
    }
  },
  components: {
    'TopMenu': TopMenu,
    'Footer': Footer
  },
  beforeMount() {
    const path = this.$route.path.split('/')
    let language = {
      text: '',
      value: ''
    }

    if (path.length > 0) {
      switch (path[1]) {
        case 'nl':
        case 'en':
          language.value = path[1]
          break
        default:
          /*for (let idx in navigator.languages) {
            const navLanguage = navigator.languages[idx]

            switch (navLanguage) {
              case 'nl':
              case 'en':
                language.value = navLanguage
                break
            }

            if (language.value !== '') {
              break
            }
          }*/

          if (language.value === '') {
            language.value = 'en'
          }
      }
    }

    switch (language.value) {
      case 'nl':
        language.text = 'Nederlands'
        break
      case 'en':
        language.text = 'English'
        break
    }

    this.$store.commit("language", language)
  }
}



// WEBPACK FOOTER //
// ./src/pages/page/advice-and-support/advice-and-support.js